import * as React from "react";
import {NewCardForm} from "@ferry/journey-services";
import {authorize} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {CardForm} from "../../../../../components/payments/CardForm";
import {getSessionStorage, setSessionStorage} from "../../../../../CommonFunctions";
import {Types} from "../../../../../Types";
import type {ICustomerPortalService} from "../../../../../services/ICustomerPortalService";

interface IProps {
    verifyNewCardFailed: boolean,
    policyNumber?: string;
    invoiceId?: string;
}

interface IState {
    newCardForm?: NewCardForm,
    reuseCard: boolean,
    policyNumber?: string
}

@authorize
export class MissedPaymentForm extends React.Component<IProps, IState> {
    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            newCardForm: undefined,
            reuseCard: false
        };
    }

    public componentDidMount() {
        const policyNumber: string =  this.props.policyNumber ?? getSessionStorage("missedPaymentPolicyNumber");
        this.customerPortalService.autNewCardForMissedPayment(policyNumber, this.props.invoiceId, false).subscribe((newCardForm: NewCardForm) => {
            this.setState({
                newCardForm,
                policyNumber
            })

            setSessionStorage("isChargeBack", false);
            setSessionStorage("missedPaymentPolicyNumber", policyNumber);
        });
    }

    public render() {
        return (
            <CardForm newCardForm={this.state.newCardForm} verifyNewCardFailed={this.props.verifyNewCardFailed} policyNumber={this.props.policyNumber}/>
        );
    }
}
